import { render, staticRenderFns } from "./PostNewJob.vue?vue&type=template&id=258ca823&scoped=true&"
import script from "./PostNewJob.vue?vue&type=script&lang=ts&"
export * from "./PostNewJob.vue?vue&type=script&lang=ts&"
import style0 from "./PostNewJob.vue?vue&type=style&index=0&id=258ca823&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258ca823",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCol,VRow})
